import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

declare global {
  interface Window {
    map: maplibregl.Map
  }
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
